import React from 'react'
import { cn } from '@/lib/utils'

import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogHeader,
  DialogTitle,
} from './dialog'

interface ModalProps {
  isOpen: boolean
  onOpenChange: (open: boolean) => void
  title: string
  description?: string
  children: React.ReactNode
  className?: string
  titlePosition?: 'left' | 'center'
  showCloseButton?: boolean
}

export function Modal({
  isOpen,
  onOpenChange,
  title,
  description,
  children,
  className,
  titlePosition = 'left',
  showCloseButton = true,
}: ModalProps) {
  return (
    <Dialog open={isOpen} onOpenChange={onOpenChange}>
      <DialogContent
        className={cn('flex flex-col', className || '')}
        showCloseButton={showCloseButton}
      >
        <DialogHeader className='flex-shrink-0 pb-2'>
          <DialogTitle
            className={titlePosition === 'center' ? 'text-center' : 'text-left'}
          >
            {title}
          </DialogTitle>
          <DialogDescription className={description ? '' : 'sr-only'}>
            {description || 'Dialog'}
          </DialogDescription>
        </DialogHeader>

        <div className='flex-1 flex flex-col min-h-0'>{children}</div>
      </DialogContent>
    </Dialog>
  )
}
